module.exports = __webpack_public_path__ + "img/prosper-africa.78d20da6.svg";